'use client';

import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import CarouselContent from './CarouselContent';
import CarouselImage from './CarouselImage';
import PlayArrowSvg from '../images/play_arrow.svg';
import CarouselStyles from './style';

function Carousel({ userName, heading, description, tags, buttonText, buttonIcon, carouselImage }) {
    return (
        <Box component="section" sx={CarouselStyles.container} className="carousel-section">
            <CarouselContent userName={userName} heading={heading} description={description} tags={tags} buttonText={buttonText} buttonIcon={buttonIcon} />
            <CarouselImage imageUrl={carouselImage} />
        </Box>
    );
}

Carousel.propTypes = {
    userName: PropTypes.string,
    heading: PropTypes.string,
    description: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    buttonText: PropTypes.string,
    buttonIcon: PropTypes.string,
    carouselImage: PropTypes.string.isRequired,
};

Carousel.defaultProps = {
    userName: '',
    heading: 'Accelerate Development and Innovation',
    description:
        'DevX Infra helps you begin your journey with easy-to-use, intuitive Solutions and Services. Harness the power of cloud-based, pre-approved Solutions and Atomic services to turn your vision into reality in just days. Simplify onboarding and optimize spending with smart, efficient tools.',
    tags: ['Streamline Onboarding', 'Smart Spending', 'Reality in Days'],
    buttonText: 'Explore Solutions',
    buttonIcon: PlayArrowSvg,
};

export default Carousel;
